import { render, staticRenderFns } from "./FileControl.vue?vue&type=template&id=01616d8c&scoped=true&"
import script from "./FileControl.vue?vue&type=script&lang=js&"
export * from "./FileControl.vue?vue&type=script&lang=js&"
import style0 from "./FileControl.vue?vue&type=style&index=0&id=01616d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01616d8c",
  null
  
)

export default component.exports